export default __webpack_public_path__ + "static/media/play.36c8ac92.png";